<template>
  <v-subheader>
    <v-layout justify-space-between align-center row>
      Alunos
      <div>
        <v-checkbox input-value="true" v-model="checked" hide-details class="mt-0 pt-0" data-test="selection-checkbox"/>
      </div>
    </v-layout>
  </v-subheader>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'StudentListHeader',

  methods: {
    ...mapActions({
      changeStudentsSelection: 'responsibleInfos/changeStudentsSelection'
    })
  },

  computed: {
    checked: {
      get () {
        return this.isAllStudentsSelected
      },

      set () {
        this.changeStudentsSelection()
      }
    },
    ...mapState({
      isAllStudentsSelected: state => state.responsibleInfos.isAllStudentsSelected
    })
  }
}
</script>
